import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Logo from "../../assets/logo/Logo-Trans.png";
import image from "../../assets/logo/auth.png";
import "react-phone-input-2/lib/style.css";
import CountrySelect from "../../test/CountrySelect";
//
export default function VerifyPhone() {
  const [mobileNumber, setMobileNumber] = useState("");
  const [responseMessage, setResponseMessage] = useState("");
  const navigate = useNavigate();
  const handleMobileNumberChange = (e) => {
    if (e && e.target) {
      setMobileNumber(e.target.value);
    }
  };

  return (
    <>
      <div className="xs:min-h-screen">
        <div className=" lg:hidden --logo flex justify-center  ">
          <img
            src={Logo}
            alt=""
            className="lg:w-[104px] xs:h-[49px] fade-in xs:mt-12 "
          />
        </div>
        <div className="flex flex-row justify-between bg-[#cb22290f]  ">
          <div className="xs:hidden item-1 h-screen flex flex-col justify-evenly lg:w-[50%] bg-[#cb22290f]">
            <div className="flex flex-col justify-center items-center mt-5 gap-[8pxs]">
              <img
                src={Logo}
                alt=""
                className="lg:w-[104px] fade-in "
              />
            </div>
            <div className="text">
              <h1 className="text-center font-bold text-[35px] leading-[30px] text-[#738482] mt-2">
                Welcome to INO
              </h1>
              <p className="text-center  text-[#738482] font-all font-semibold ">
                Register now to gain access to your account{" "}
              </p>
            </div>
            {/*  */}
            <div className="image relative top-[4px]">
              <img
                src={image}
                className="mx-ato m-auto h-[21rem] image-coin"
                alt=""
              />
            </div>
            {/*  */}
            <div className="flex flex-row items-center gap-4 justify-center">
              <p className="text-[14px]">License Policy</p>
              <p className="border-x p-[8px]  text-[14px] border-black">
                Privacy Policy
              </p>
              <p className="text-[14px]">Terms and Conition</p>
            </div>
            <p className="text-[#738482] text-[13px] text-center">
              Copyrights © 2023 All Rights Reserved by{" "}
              <span className="text-[#CB2229]">INO</span>{" "}
            </p>
          </div>
          <div className=" fade-in-left item-2 bg-[#cb22290f] xs:bg-white w-[60%] flex justify-center xs:w-[100%]">
            <CountrySelect />
          </div>
        </div>
      </div>
    </>
  );
}
// navigate('/');
//
